import React, { useState } from 'react'

// Styles
import { Flags, FlagsOpened, Countries, Overlay, LinkFlags } from './style'

// Components
import Icon from '../Icon/index' 
import OrangeIcon from '../Icon/OrangeDsIcon'

// Data
import FlagsCountriesContentJSON from './FlagsCountriesContent.json'
interface ILanguage {
  typeLanguage?: string;
  setTypeLanguage: Function;
  toggleMenu: Function;
  menuActive: boolean;
}

type languageProps = {
  flag: string;
  country: string;
  url: string;
}

const FlagsCountries = ({ typeLanguage, setTypeLanguage, toggleMenu, menuActive }: ILanguage) => {  
  const [ flags, setFlags ] = useState(false)

  function HandleChange () {
    toggleMenu(menuActive)
    setFlags(false)
  }

  return(
    <>
      <Flags onClick={() => setFlags(!flags)} open={flags} className='justify-content-between'>
        <span className='d-flex align-items-center'>
          {typeLanguage === 'EN' &&
            <>
              <OrangeIcon size='MD' icon='eua' className='mr-3 mr-md-2' />
              <span className='fs-14 lh-17 text-blue-900 d-lg-none'>United States</span>
            </>
          }
          {typeLanguage === 'ES' &&
            <>
              <OrangeIcon size='MD' icon='spain' className='mr-3 mr-md-2' />
              <span className='fs-14 lh-17 text-blue-900 d-lg-none'>Spain</span>
            </>
          }
          {typeLanguage === 'PT' &&
            <>
              <OrangeIcon size='MD' icon='portugal' className='mr-3 mr-md-2' />
              <span className='fs-14 lh-17 text-blue-900 d-lg-none'>Portugal</span>
            </>
          }
        </span>
        <span className='icon-chevron'>
          <Icon width='24' height='24' icon='navigation/chevron-down' directory='v2' color='orange-medium' />
        </span>  
      </Flags>
      {flags ? <Overlay className='d-lg-none' /> : ''}
      {
        <>
          <Countries className='px-3 py-2' open={flags}>
            <div className='trace-menu d-lg-none'/>
            <div className='d-flex justify-content-between py-4 d-lg-none'>
              <span className='fs-16 text-blue-900 fw-600'>{typeLanguage === 'EN' ? 'Country' : 'País'}</span>
              <span className='fs-14 text-orange-medium fw-600' onClick={() => setFlags(false)}>
                {(typeLanguage === 'EN' && 'Close') || (typeLanguage === 'ES' && 'Cerrar') || (typeLanguage === 'PT' && 'Fechar')}</span>
            </div>
            {FlagsCountriesContentJSON.map((item: languageProps)=>(
              <LinkFlags key={item.country} title={item.country} onClick={() => {setTypeLanguage(item.url); HandleChange()}}>
                <FlagsOpened className='pl-0 py-3'>
                  <span className='mr-3'>
                    <OrangeIcon size='MD' icon={item.flag} color='#FF7A00' />
                  </span>
                  <span className='fs-14 lh-17 text-blue-900 mr-auto'>{item.country}</span>
                  <span className='mr-0'>
                    <OrangeIcon size='MD' icon={typeLanguage === item.url ? 'radio-on' : 'radio-off'} color='#FF7A00' />
                  </span>
                </FlagsOpened>
              </LinkFlags>
            ))
            }
          </Countries>
        </>
      }
    </>
  )
}

export default FlagsCountries